import axios from "axios"
import { create } from "zustand"

export let useVideoCat = create((set, get) => ({
    cats: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "Nomi",
            dataIndex: "title",
            key: "title",
        },
    ],
    ed: {},
    setEd: (ed) => set({ ed }),
    setCats: () => {
        axios.get('/video-categories')
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ cats: data });
            })
            .catch((err) => {
                console.error('Video kategoriyalarini yuklab olishda xatolik:', err);
                set({ cats: [] });
            })
    },
    addCat: (cat) => {
        axios.post('/video-categories', cat)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Video kategoriyasi qo\'shishda xatolik:', err);
            })
    },  
    editCat: (cat) => {
        axios.put('/video-categories/' + cat.id, cat)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Video kategoriyasini taxrirlashda xatolik:', err);
            })
    },
    delCat: (id) => {
        axios.delete('/video-categories/' + id)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Video kategoriyasini o\'chirishda xatolik:', err);
            })
    }
}))